<script>
  console.log("check")
  import MenuBar from "../../components/menuBar/MenuBar.svelte";
  import { afterUpdate, onMount, tick } from "svelte";
  import { useParams } from "svelte-navigator";
  import { derived } from 'svelte/store';
  import { writable } from 'svelte/store';

  import { usePageContext } from "../../components/pages/pageContext.js";
  import GeneralSelect from "../../components/select/GeneralSelect.svelte";
  import GeneralPanelButton from "../../components/button/GeneralPanelButton.svelte";
  import Loading from "../../components/pages/Loading.svelte";
  import { fetchProjectData } from "../../utils/getData";
  import { saveConfiguration, getConfiguration } from "../../utils/configurationStorage/configurationStorage.js";

  import fetchData from "../../utils/loadGraphFetchData.js";
  import LoadTableArea from "../../components/loadgraph/LoadTableArea.svelte";
  import LoadExtraTableArea from "../../components/loadgraph/LoadExtraTableArea.svelte";
  import LoadDataArea from "../../components/loadgraph/LoadDataArea.svelte";
  /* import LoadGraphMenuDialog from "../../components/loadgraph/LoadGraphMenuDialog.svelte"; */
  import { translate } from "../../i18n/i18next.js";
  import MenuBarMenuDialog from "../../components/menuBar/menuDialog/MenuBarMenuDialog.svelte";
  import MenuBarMenuDialogButton from "../../components/menuBar/menuDialog/MenuBarMenuDialogButton.svelte";
  import LoadGraphDisplaySettingsMenuDialog from "../../components/loadgraph/LoadGraphDisplaySettingsMenuDialog.svelte";
  import LoadGraphFilterMenuDialog from "../../components/loadgraph/LoadGraphFilterMenuDialog.svelte";
  import { createLoadGraphFilters } from "../../components/loadgraph/LoadGraphFilters.js";

  import {
    border,
    dataDay,
    dataMonth,
    dataWeek,
    daysToShow,
    monthsToShow,
    mostRecentChange,
    rowsToShow,
    selectedDisplayPeriodS,
    selectedDisplayRowNumS,
    selectedUnitPeriodS,
    startDayIndex,
    startMonthIndex,
    startRowIndex,
    startWeekIndex,
    timeGroupsDay,
    timeGroupsMonth,
    timeGroupsWeek,
    tmpMaxRow,
    viewportHeight,
    viewportWidth,
    weeksToShow,
    groupFilterInput,
    resFilterInput,
    procFilterInput,
    shiftFilterInput,
    Filters,
  } from "../../components/loadgraph/loadGraphStore.js";
  import MenuBarItem from "../../components/menuBar/MenuBarItem.svelte";

  const params = useParams();
  const projectId = $params.project;
  let uploadTimeStamp = undefined;

  let tableHeaders = [];
  let emptyText;
  // The unit period options and display period options
  const unitPeriod = [
    { text: "日", value: "day" },
    { text: "週", value: "week" },
    { text: "月", value: "month" }
  ];

  let displayPeriod = [
    { text: "1日", value: "1day" },
    { text: "3日", value: "3day" },
    { text: "1週間", value: "1week" },
    { text: "2週間", value: "2week" },
    { text: "1ヶ月", value: "1month" },
    { text: "2ヶ月", value: "2month" },
    { text: "3ヶ月", value: "3month" }
  ];

  let selectedUnitPeriod;
  let selectedDisplayPeriod;
  let selectedDisplayRowNum;

  let tableHeader;

  let isLoading = true;

  // subscribe to the selected filters
  selectedUnitPeriodS.subscribe((value) => (selectedUnitPeriod = value));
  selectedDisplayPeriodS.subscribe((value) => (selectedDisplayPeriod = value));
  selectedDisplayRowNumS.subscribe((value) => (selectedDisplayRowNum = value));

  // default setting for display mode
  let viewMode = "colorScale";

  const displayOptions = [
    { text: "カラースケール", value: "colorScale" },
    { text: "データバー", value: "dataBar" },
  ];

  // set up header title
  // load graph have not added to i18n.js
  const { setHeaderProps } = usePageContext();
  $: setHeaderProps({
    title: `${"Sample1"} - 負荷率グラフ`,
  });
  $: setHeaderProps({ uploadTime: uploadTimeStamp});

  const rowHeight = derived(
    [viewportHeight, rowsToShow, border],
    ([$viewportHeight, $rowsToShow, $border]) => {
      const titleHeight = 51;
      const toolbarHeight = 50;
      const tableHeaderHeight = 80;
      const footerHeight = 30;
      const remainingHeight = $viewportHeight - titleHeight - toolbarHeight - tableHeaderHeight - footerHeight - $border*(2+$rowsToShow);
      return remainingHeight / $rowsToShow;
    }
  );

  const tableAreaWidth = writable({
    0: 180,
    1: 180,
    2: 190,
    3: 150
  });

  const cellWidth = derived(
    [selectedUnitPeriodS, viewportWidth, daysToShow, weeksToShow, monthsToShow, border, tableAreaWidth],
    ([$selectedUnitPeriodS, $viewportWidth, $daysToShow, $weeksToShow, $monthsToShow, $border, $tableAreaWidth]) => {
      let totalWidth = Object.values($tableAreaWidth).reduce((acc, width) => acc + width, 0);

      let remainingWidth = $viewportWidth - totalWidth;

      if ($selectedUnitPeriodS === "day") {
        remainingWidth -= $border*(4+ ($daysToShow+1));
        return (remainingWidth / $daysToShow);
      } else if ($selectedUnitPeriodS === "week") {
        remainingWidth -= $border*(4+ ($weeksToShow+1));
        return (remainingWidth / $weeksToShow);
      } else if ($selectedUnitPeriodS === "month") {
        remainingWidth -= $border*(4+ ($monthsToShow+1));
        return (remainingWidth / $monthsToShow);
      }
    }
  );

  const filteredData = derived(
    [dataDay, dataWeek, dataMonth, groupFilterInput, resFilterInput, procFilterInput, shiftFilterInput, selectedUnitPeriodS],
    ([$dataDay, $dataWeek, $dataMonth, $groupFilterInput, $resFilterInput, $procFilterInput, $shiftFilterInput, $selectedUnitPeriodS]) => {
      let sourceData;
      if ($selectedUnitPeriodS === 'day') {
        sourceData = $dataDay;
      } else if ($selectedUnitPeriodS === 'week') {
        sourceData = $dataWeek;
      } else if ($selectedUnitPeriodS === 'month') {
        sourceData = $dataMonth;
      }
      return sourceData.filter(d => {
        let exclude = false;

        // Loop through each filter
        const filters = [
          { name: 'group', filter: $groupFilterInput },
          { name: 'resourceCode', filter: $resFilterInput },
          { name: 'process', filter: $procFilterInput },
          { name: 'shift', filter: $shiftFilterInput }
        ];

        for (const { name, filter } of filters) {
          if (filter && filter.includes(d[name])) {
            exclude = true;
            break; // Stop checking further filters once we decide to exclude the row
          }
        }

        // If exclude is set, the row will not be included in the result
        return !exclude;
      });
    }
  );
  const visibleRows = derived(
    [dataDay, dataWeek, dataMonth, selectedUnitPeriodS, startRowIndex, rowsToShow, tmpMaxRow, filteredData],
    ([$dataDay, $dataWeek, $dataMonth, $selectedUnitPeriodS, $startRowIndex, $rowsToShow, $tmpMaxRow, $filteredData]) => {

      if ($selectedUnitPeriodS === "day") {
        if ($tmpMaxRow >= 0) {
          return $filteredData.slice($startRowIndex, $startRowIndex + $rowsToShow);
        } else {
          return $dataDay.slice($startRowIndex, $startRowIndex + $rowsToShow);
        }
      } else if ($selectedUnitPeriodS === "week") {
        if ($tmpMaxRow >= 0) {
          return $filteredData.slice($startRowIndex, $startRowIndex + $rowsToShow);
        } else {
          return $dataWeek.slice($startRowIndex, $startRowIndex + $rowsToShow);
        }
      } else if ($selectedUnitPeriodS === "month") {
        if ($tmpMaxRow >= 0) {
          return $filteredData.slice($startRowIndex, $startRowIndex + $rowsToShow);
        } else {
          return $dataMonth.slice($startRowIndex, $startRowIndex + $rowsToShow);
        }
      }

      return [];  // Default return value if no conditions are met
    }
  );
  const visibleDays = derived(
    [timeGroupsDay, startDayIndex, daysToShow],
    ([$timeGroupsDay, $startDayIndex, $daysToShow]) => {
      let visibleDays = [];
      const allDays = Object.values($timeGroupsDay).flat();
      for (let i = $startDayIndex; i < $startDayIndex + $daysToShow; i++) {
        if (i < allDays.length) {
          visibleDays.push(allDays[i]);
        }
      }
      return visibleDays;
    }
  );

  const visibleWeeks = derived(
    [timeGroupsWeek, startWeekIndex, weeksToShow],
    ([$timeGroupsWeek, $startWeekIndex, $weeksToShow]) => {
      let visibleWeeks = [];
      const allWeeks = Object.values($timeGroupsWeek).flat();
      for (let i = $startWeekIndex; i < $startWeekIndex + $weeksToShow; i++) {
        if (i < allWeeks.length) {
          visibleWeeks.push(allWeeks[i]);
        }
      }
      return visibleWeeks;
    }
  );

  const visibleMonths = derived(
    [timeGroupsMonth, startMonthIndex, monthsToShow],
    ([$timeGroupsMonth, $startMonthIndex, $monthsToShow]) => {
      let visibleMonths = [];
      const allMonths = Object.values($timeGroupsMonth).flat();
      for (let i = $startMonthIndex; i < $startMonthIndex + $monthsToShow; i++) {
        if (i < allMonths.length) {
          visibleMonths.push(allMonths[i]);
        }
      }
      return visibleMonths;
    }
  );

  const rowNumMaxValue = derived(
    [dataWeek, startRowIndex],
    ([$dataWeek, $startRowIndex]) => {
      return Math.min($dataWeek.length - $startRowIndex, 30);
    }
  );

  const FilterableItems = derived([Filters], ([Filters]) => {
    return Object.fromEntries(
      Object.keys(Filters)
        .map(filterName => [filterName, Filters[filterName].getFilterItems($dataWeek, Filters)])
    )
  });
  
  function handleClearAllFilters() {
    Filters.set(createLoadGraphFilters($dataWeek));
    startWeekIndex.set(0);
    tmpMaxRow.set(-1);
    
  }

  let isInitialLoadComplete = false;
  $: {
    if (isInitialLoadComplete && (selectedUnitPeriodS || selectedDisplayPeriodS || selectedDisplayRowNumS || groupFilterInput || resFilterInput || procFilterInput || shiftFilterInput)) {
      const configuration = {
        "selectedUnitPeriod": $selectedUnitPeriodS,
        "selectedDisplayPeriod": $selectedDisplayPeriodS,
        "selectedDisplayRowNum": $selectedDisplayRowNumS,
        "groupFilterInput": $groupFilterInput,
        "resFilterInput": $resFilterInput,
        "procFilterInput": $procFilterInput,
        "shiftFilterInput": $shiftFilterInput,
      }
      saveConfiguration("LoadGraph", "default", "default", configuration);
    }
  }

  $: {
    if (
      $groupFilterInput ||
      $resFilterInput ||
      $procFilterInput ||
      $shiftFilterInput
    ) {
      if (selectedUnitPeriod === "day") {
        tmpMaxRow.set($filteredData.length);
        startRowIndex.set(0);
      } else if (selectedUnitPeriod === "week") {
        tmpMaxRow.set($filteredData.length);
        startRowIndex.set(0);
      } else if (selectedUnitPeriod === "month") {
        tmpMaxRow.set($filteredData.length);
        startRowIndex.set(0);
      }
      if ($filteredData.length === 0) {
        if ($mostRecentChange.group) {
          emptyText = "グループ";
        } else if ($mostRecentChange.resourceCode) {
          emptyText = "資源コード";
        } else if ($mostRecentChange.process) {
          emptyText = "工程";
        } else if ($mostRecentChange.shift) {
          emptyText = "勤務シフト";
        }
      }
    }
  }

  // Function to update the dates to show based on the selected display period
  function updateDatesToShow() {
    if (selectedDisplayPeriod === "1day") {
      daysToShow.set(1);
      weeksToShow.set(1);
      monthsToShow.set(1);
    } else if (selectedDisplayPeriod === "3day") {
      daysToShow.set(3);
      weeksToShow.set(1);
      monthsToShow.set(1);
    } else if (selectedDisplayPeriod === "1week") {
      daysToShow.set(7);
      weeksToShow.set(1);
      monthsToShow.set(1);
    } else if (selectedDisplayPeriod === "2week") {
      daysToShow.set(14);
      weeksToShow.set(2);
      monthsToShow.set(1);
    } else if (selectedDisplayPeriod === "1month") {
      daysToShow.set(30);
      weeksToShow.set(5);
      monthsToShow.set(1);
    } else if (selectedDisplayPeriod === "2month") {
      daysToShow.set(60);
      weeksToShow.set(9);
      monthsToShow.set(2);
    } else if (selectedDisplayPeriod === "3month") {
      daysToShow.set(90);
      weeksToShow.set(13);
      monthsToShow.set(3);
    }
  }

  $: {
    if (
      selectedDisplayPeriod
    ) {
      updateDatesToShow();
    }
  }

  $: {
    if (selectedDisplayRowNum) {
      (async () => {
        await tick(); // Wait for the DOM to be fully initialized

        rowsToShow.set(+selectedDisplayRowNum);
      })();
    }
  }

  // Reset startedRowIndex to 0 when the filter is used
  $: {
    if (
      $groupFilterInput ||
      $resFilterInput ||
      $procFilterInput ||
      $shiftFilterInput
    ) {
      startRowIndex.set(0);
    }
  }

  // Fetch data from the JSON file
  async function loadData(projectId) {
    const projectData = await fetchProjectData(projectId, "LoadGraph");
    uploadTimeStamp = projectData.UploadTimeStamp;

    const result = await fetchData(projectId);
    tableHeaders = result.tableHeaders;

    // Separate the time groups and data for day, week, and month
    timeGroupsDay.set(result.timeGroups.day);
    timeGroupsWeek.set(result.timeGroups.week);
    timeGroupsMonth.set(result.timeGroups.month);
    dataDay.set(
    result.data.map(resource => ({
      ...resource,
      percentages: resource.percentages.day
    })));
    dataWeek.set(
      result.data.map(resource => ({
        ...resource,
        percentages: resource.percentages.week
      })));
    dataMonth.set(
      result.data.map(resource => ({
        ...resource,
        percentages: resource.percentages.month
      })));
    Filters.set(createLoadGraphFilters($dataWeek));

    startRowIndex.set(0);
  }

  // Navigate to the next week
  function nextWeek(flag) {
    // flag is used to determine if the user clicked the double arrow button
    // 0 for single arrow, 1 for double arrow
    // separate the calculation for day, week and month
    if (selectedUnitPeriod === "day") {
      if (flag === 0) {
        startDayIndex.set(Math.min(
          $startDayIndex + 1,
          Math.max(Object.values($timeGroupsDay).flat().length - $daysToShow, 0)
        ));
      } else {
        startDayIndex.set(Math.min(
          $startDayIndex + $daysToShow,
          Math.max(Object.values($timeGroupsDay).flat().length - $daysToShow, 0)
        ));
      }
      startWeekIndex.set(Math.floor($startDayIndex / 7));
      startMonthIndex.set(Math.floor($startDayIndex / 30));

    } else if (selectedUnitPeriod === "week") {
      if (flag === 0) {
        startWeekIndex.set(Math.min(
          $startWeekIndex + 1,
          Math.max(Object.values($timeGroupsWeek).flat().length - $weeksToShow, 0)
        ));
      } else {
        startWeekIndex.set(Math.min(
          $startWeekIndex + $weeksToShow,
          Math.max(Object.values($timeGroupsWeek).flat().length - $weeksToShow, 0)
        ));
      }
      startDayIndex.set($startWeekIndex * 7);
      startMonthIndex.set(Math.floor($startDayIndex / 30));

    } else if (selectedUnitPeriod === "month") {
      if (flag === 0) {
        startMonthIndex.set(Math.min(
          $startMonthIndex + 1,
          Math.max(Object.values($timeGroupsMonth).flat().length - $monthsToShow, 0)
        ));
      } else {
        startMonthIndex.set(Math.min(
          $startMonthIndex + $monthsToShow,
          Math.max(Object.values($timeGroupsMonth).flat().length - $monthsToShow, 0)
        ));
      }
      startDayIndex.set($startMonthIndex * 30);
      startWeekIndex.set(Math.floor($startDayIndex / 7));
    }
  }

  // Navigate to the previous week
  function previousWeek(flag) {
    // flag is used to determine if the user clicked the double arrow button
    // 0 for single arrow, 1 for double arrow
    // separate the calculation for day, week and month
    if (selectedUnitPeriod === "day") {
      if (flag === 0) {
        startDayIndex.set(Math.max($startDayIndex - 1, 0));
      } else {
        startDayIndex.set(Math.max($startDayIndex - $daysToShow, 0));
      }
      startWeekIndex.set(Math.floor($startDayIndex / 7));
      startMonthIndex.set(Math.floor($startDayIndex / 30));

    } else if (selectedUnitPeriod === "week") {
      if (flag === 0) {
        startWeekIndex.set(Math.max($startWeekIndex - 1, 0));
      } else {
        startWeekIndex.set(Math.max($startWeekIndex - $weeksToShow, 0));
      }
      startDayIndex.set($startWeekIndex * 7);
      startMonthIndex.set(Math.floor($startDayIndex / 30));
    } else if (selectedUnitPeriod === "month") {
      if (flag === 0) {
        startMonthIndex.set(Math.max($startMonthIndex - 1, 0));
      } else {
        startMonthIndex.set(Math.max($startMonthIndex - $monthsToShow, 0));
      }
      startDayIndex.set($startMonthIndex * 30);
      startWeekIndex.set(Math.floor($startDayIndex / 7));
    }
  }

  // Navigate to the next row
  function nextRow(flag) {
    // flag is used to determine if the user clicked the double arrow button
    // 0 for single arrow, 1 for double arrow
    if (flag === 0) {
      // max function is used to prevent the startRowIndex from being negative
      if ($tmpMaxRow >= 0) {
        startRowIndex.set(Math.min(
          $startRowIndex + 1,
          Math.max(Math.min($tmpMaxRow, $dataWeek.length) - $rowsToShow, 0)
        ));
      } else {
        startRowIndex.set(Math.min(
          $startRowIndex + 1,
          Math.max($dataWeek.length - $rowsToShow, 0)
        ));
      }
    } else {
      // max function is used to prevent the startRowIndex from being negative
      if ($tmpMaxRow >= 0) {
        startRowIndex.set(Math.max(
          Math.min($tmpMaxRow, $dataWeek.length) - $rowsToShow,
          0
        ));
      } else {
        startRowIndex.set(Math.min(
          $startRowIndex + $rowsToShow,
          Math.max($dataWeek.length - $rowsToShow, 0)
        ));
      }
    }
  }

  // Navigate to the previous row
  function previousRow(flag) {
    // flag is used to determine if the user clicked the double arrow button
    // 0 for single arrow, 1 for double arrow
    if (flag === 0) {
      startRowIndex.set(Math.max($startRowIndex - 1, 0));
    } else {
      startRowIndex.set(Math.max($startRowIndex - $rowsToShow, 0));
    }
  }

  // Function for the button "開始" to move the data to start point
  function MoveButton_ToStart() {
    startDayIndex.set(0);
    startWeekIndex.set(0);
    startMonthIndex.set(0);
  }

  // Function for the button "今月" to move the data to the current month
  function MoveButton_Today() {
    // Get the current date
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    // Format the date as "YYYY年M月"
    const formattedDate = `${year}年${month}月`;
    const months = Object.keys($timeGroupsWeek);

    // Find the index of the current month in the timeGroups object
    let weekIndex = 0;
    let dayIndex = 0;
    let monthIndex = 0;
    for (let i = 0; i < months.length; i++) {
      if (months[i] === formattedDate) {
        startWeekIndex.set(weekIndex);
        startDayIndex.set(dayIndex);
        startMonthIndex.set(monthIndex);
        break;
      }
      weekIndex += $timeGroupsWeek[months[i]].length;
      dayIndex += $timeGroupsDay[months[i]].length;
      monthIndex += 1;
    }
    // maybe add some pseudo dates without data
    let newPeriodText, newPeriodValue;
    if (selectedUnitPeriod === "week") {
      daysToShow.set(Math.min($daysToShow, Object.values($timeGroupsDay).flat().length - $startDayIndex));
      weeksToShow.set(Math.min($weeksToShow, Object.values($timeGroupsWeek).flat().length - $startWeekIndex));
      monthsToShow.set(Math.min($monthsToShow, Object.values($timeGroupsMonth).flat().length - $startMonthIndex));
      newPeriodText = `${$weeksToShow}週間`;
      newPeriodValue = `${$weeksToShow}week`;
    } else if (selectedUnitPeriod === "day") {
      daysToShow.set(Math.min($daysToShow, Object.values($timeGroupsDay).flat().length - $startDayIndex));
      weeksToShow.set(Math.min($weeksToShow, Object.values($timeGroupsWeek).flat().length - $startWeekIndex));
      monthsToShow.set(Math.min($monthsToShow, Object.values($timeGroupsMonth).flat().length - $startMonthIndex));
      newPeriodText = `${$daysToShow}日`;
      newPeriodValue = `${$daysToShow}day`;
    } else if (selectedUnitPeriod === "month") {
      daysToShow.set(Math.min($daysToShow, Object.values($timeGroupsDay).flat().length - $startDayIndex));
      weeksToShow.set(Math.min($weeksToShow, Object.values($timeGroupsWeek).flat().length - $startWeekIndex));
      monthsToShow.set(Math.min($monthsToShow, Object.values($timeGroupsMonth).flat().length - $startMonthIndex));
      newPeriodText = `${$monthsToShow}ヶ月`;
      newPeriodValue = `${$monthsToShow}month`;
    }
    
    customOption = { text: newPeriodText, value: newPeriodValue, isCustom: true };
    displayPeriod = [...displayPeriod.filter(option => !option.isCustom), customOption];

    selectedDisplayPeriodS.set(newPeriodValue);
    handleSelect(document.getElementById("displayPeriodSelect"));
  }

  async function handleSelect(target) {
    if (!target) {
        return; // Exit the function early if selectElement is null
    }
    await tick();
    if (target.options.length != 8) {
        return;
    }
    // Check if the selected option is the custom one (with isCustom = true)
    target.style.color = 'grey';
    const options = target.options;
    for (let i = 0; i < options.length; i++) {
        if (i === options.length - 1) {
            break;
        }
        const option = options[i];
        option.style.color = 'black';
    }
  }
  
  let customOption = null;
  function handleScrollPeriodHeader(event) {
    event.preventDefault();
    if (event.ctrlKey) {
      let newPeriodText, newPeriodValue;
      if (selectedUnitPeriod === "week") {
        if (event.deltaY < 0) {
          weeksToShow.set(Math.max($weeksToShow - 1, 1));
        } else {
          weeksToShow.set(Math.min($weeksToShow + 1, Object.values($timeGroupsWeek).flat().length - $startWeekIndex));
          
        }
        daysToShow.set($weeksToShow * 7);
        monthsToShow.set(Math.ceil($daysToShow / 30));
        newPeriodText = `${$weeksToShow}週間`;
        newPeriodValue = `${$weeksToShow}week`;
      } else if (selectedUnitPeriod === "day") {
        if (event.deltaY < 0) {
          daysToShow.set(Math.max($daysToShow - 1, 1));
        } else {
          
          daysToShow.set(Math.min($daysToShow + 1, Object.values($timeGroupsDay).flat().length - $startDayIndex));
        }
        weeksToShow.set(Math.ceil($daysToShow / 7));
        monthsToShow.set(Math.ceil($daysToShow / 30));
        newPeriodText = `${$daysToShow}日`;
        newPeriodValue = `${$daysToShow}day`;
      } else if (selectedUnitPeriod === "month") {
        if (event.deltaY < 0) {
          monthsToShow.set(Math.max($monthsToShow - 1, 1));
        } else {
          monthsToShow.set(Math.min($monthsToShow + 1, Object.values($timeGroupsMonth).flat().length- $startMonthIndex));
        }
        daysToShow.set($monthsToShow * 30);
        weeksToShow.set(Math.ceil($daysToShow / 7));
        newPeriodText = `${$monthsToShow}ヶ月`;
        newPeriodValue = `${$monthsToShow}month`;
      }
      
      customOption = { text: newPeriodText, value: newPeriodValue, isCustom: true };
      displayPeriod = [...displayPeriod.filter(option => !option.isCustom), customOption];

      selectedDisplayPeriodS.set(newPeriodValue);
      handleSelect(document.getElementById("displayPeriodSelect"));
    } else {
      if (event.deltaY < 0) {
          previousWeek(0);
      } else {
          nextWeek(0);
      }
    }
  }

  function handleScrollPeriodBody(event) {
    event.preventDefault();
    if (event.ctrlKey) {
      let newPeriodText, newPeriodValue;
      if (selectedUnitPeriod === "week") {
        if (event.deltaY < 0) {
          weeksToShow.set(Math.max($weeksToShow - 1, 1));
        } else {
          weeksToShow.set(Math.min($weeksToShow + 1, Object.values($timeGroupsWeek).flat().length - $startWeekIndex));
          
        }
        daysToShow.set($weeksToShow * 7);
        monthsToShow.set(Math.ceil($daysToShow / 30));
        newPeriodText = `${$weeksToShow}週間`;
        newPeriodValue = `${$weeksToShow}week`;
      } else if (selectedUnitPeriod === "day") {
        if (event.deltaY < 0) {
          daysToShow.set(Math.max($daysToShow - 1, 1));
        } else {
          
          daysToShow.set(Math.min($daysToShow + 1, Object.values($timeGroupsDay).flat().length - $startDayIndex));
        }
        weeksToShow.set(Math.ceil($daysToShow / 7));
        monthsToShow.set(Math.ceil($daysToShow / 30));
        newPeriodText = `${$daysToShow}日`;
        newPeriodValue = `${$daysToShow}day`;
      } else if (selectedUnitPeriod === "month") {
        if (event.deltaY < 0) {
          monthsToShow.set(Math.max($monthsToShow - 1, 1));
        } else {
          monthsToShow.set(Math.min($monthsToShow + 1, Object.values($timeGroupsMonth).flat().length- $startMonthIndex));
        }
        daysToShow.set($monthsToShow * 30);
        weeksToShow.set(Math.ceil($daysToShow / 7));
        newPeriodText = `${$monthsToShow}ヶ月`;
        newPeriodValue = `${$monthsToShow}month`;
      }
      
      customOption = { text: newPeriodText, value: newPeriodValue, isCustom: true };
      displayPeriod = [...displayPeriod.filter(option => !option.isCustom), customOption];

      selectedDisplayPeriodS.set(newPeriodValue);
      handleSelect(document.getElementById("displayPeriodSelect"));
      if (event.deltaY < 0) {
        rowsToShow.set(Math.max($rowsToShow - 1, 1));
      } else {
        // add "+" to convert string to number
        rowsToShow.set(Math.min(+$rowsToShow + 1, $rowNumMaxValue));
      }
      selectedDisplayRowNumS.set($rowsToShow);
    } else if (event.shiftKey) {
      if (event.deltaY < 0) {
          previousWeek(0);
      } else {
          nextWeek(0);
      }
    } else {
      if (event.deltaY < 0) {
          previousRow(0);
      } else {
          nextRow(0);
      }
    }
  }

  function handleScrollRowNum(event) {
    event.preventDefault();
    if (event.ctrlKey) {
      if (event.deltaY < 0) {
        rowsToShow.set(Math.max($rowsToShow - 1, 1));
      } else {
        // add "+" to convert string to number
        rowsToShow.set(Math.min(+$rowsToShow + 1, $rowNumMaxValue));
      }
      selectedDisplayRowNumS.set($rowsToShow);
    } else if (event.shiftKey) {
      event.preventDefault();
    } else {
      if (event.deltaY < 0) {
          previousRow(0);
      } else {
          nextRow(0);
      }
    }
  }

  const updateDimension = () => {
    viewportHeight.set(window.innerHeight);
    viewportWidth.set(window.innerWidth);
    border.set(parseFloat(getComputedStyle(document.querySelector('th')).borderWidth) || 0);
  };

  $: if (!isLoading) {
    afterUpdate(updateDimension); // Ensure updateRowHeight runs after DOM updates
  }

  const handleResize = () => {
    updateDimension();
  };

  function translateTimePeriod(period) {
    // Normalize the input to lowercase for easier comparison
    period = period.toLowerCase();

    // Map English time units to their Japanese counterparts
    switch (period) {
      case "day":
        return "日"; // For both "day" and "days"
      case "week":
        return "週間"; // For both "week" and "weeks"
      case "month":
        return "ヶ月"; // For both "month" and "months"
      default:
        return period; // Return the input as-is if it's unrecognized
    }
  }

  let dragging_col = null;
  let initialX = 0;
  let initialWidth = 0;
  let miniWidth = {
    0: 80,
    1: 80,
    2: 50,
    3: 80
  }

  function handleDrag(e) {
    const newColWidth = e.clientX - initialX;
    tableAreaWidth.update(current => {
      return {
        ...current,  // Spread the current values
        [parseInt(dragging_col)]: Math.max(initialWidth + newColWidth, miniWidth[parseInt(dragging_col)])   
      };
    });
  }

  function stopDrag(e) {
    window.removeEventListener('mousemove', handleDrag);
    window.removeEventListener('mouseup', stopDrag);
  }

  function startDrag(e) {
    // remove selection effect
    e.preventDefault();
    if (!e.target.id.includes("resizer_")) return;
    dragging_col = e.target.id.replace("resizer_", "");
    initialX = e.clientX;
    initialWidth = document.getElementById(`th_${dragging_col}`).offsetWidth;
    window.addEventListener('mousemove', handleDrag);
    window.addEventListener('mouseup', stopDrag);
  }
  
  onMount(() => {
    loadData(projectId).then(() => {
      // Simulate a loading state with a timeout
      isLoading = false;
      window.addEventListener('resize', handleResize);
    });

    const configuration = getConfiguration("LoadGraph", "default", "default");
    if (Object.keys(configuration).length != 0) {
      const savedSelectedDisplayPeriod = configuration.selectedDisplayPeriod;
      if (!displayPeriod.some(period => period.value === savedSelectedDisplayPeriod)) {
        const num = savedSelectedDisplayPeriod.match(/\d+/g);
        const unit = savedSelectedDisplayPeriod.match(/[a-zA-Z]+/)[0];
        if (unit === "day") {
          daysToShow.set(+num);
          weeksToShow.set(Math.ceil(+num / 7));
          monthsToShow.set(Math.ceil(+num / 30));
        } else if (unit === "week") {
          weeksToShow.set(+num);
          daysToShow.set(+num * 7);
          monthsToShow.set(Math.ceil(+num * 7 / 30));
        } else if (unit === "month") {
          monthsToShow.set(+num);
          daysToShow.set(+num * 30);
          weeksToShow.set(Math.ceil(+num * 30 / 7));
        }
        displayPeriod.push({ text: `${num}${translateTimePeriod(unit)}`, 
          value: savedSelectedDisplayPeriod, isCustom: true });
      }
      selectedUnitPeriodS.set(configuration.selectedUnitPeriod);
      selectedDisplayPeriodS.set(configuration.selectedDisplayPeriod);
      selectedDisplayRowNumS.set(configuration.selectedDisplayRowNum);
      groupFilterInput.set(configuration.groupFilterInput);
      resFilterInput.set(configuration.resFilterInput);
      procFilterInput.set(configuration.procFilterInput);
      shiftFilterInput.set(configuration.shiftFilterInput);


    }
    isInitialLoadComplete = true;

    const observer = new MutationObserver((mutationsList, observer) => {
      const element = document.getElementById("displayPeriodSelect");
      if (element) {
        handleSelect(element);
      }
    });

    // Start observing the document for changes
    observer.observe(document.body, {
      childList: true, // Watch for direct child node changes
      subtree: true,   // Watch for all descendants
    });
  
    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  let dialogCurrentlyDisplayed = null
  async function onClickSettingsDialogOpen() {
    dialogCurrentlyDisplayed = "menuSelection"
  }
  function onClickSettingsDialogClose() {
    dialogCurrentlyDisplayed = null
  }

</script>

{#if !isLoading}
  <div class="table-body">
    <MenuBar onClickDetailedMenuOpen={onClickSettingsDialogOpen}>
      <MenuBarItem slot="settings">
        <GeneralSelect options={displayOptions} bind:value={viewMode} />
      </MenuBarItem>
      <MenuBarItem slot="pagination">
        <GeneralPanelButton
          items={[
            {
              buttonText: "開始",
              buttonFunction: MoveButton_ToStart,
            },
            {
              buttonImage: "/assets/Pager_FL.svg",
              buttonFunction: () => previousWeek(1),
            },
            {
              buttonImage: "/assets/Pager_L.svg",
              buttonFunction: () => previousWeek(0),
            },
            {
              buttonText: "今月",
              buttonFunction: MoveButton_Today,
            },
            {
              buttonImage: "/assets/Pager_R.svg",
              buttonFunction: () => nextWeek(0),
            },
            {
              buttonImage: "/assets/Pager_FR.svg",
              buttonFunction: () => nextWeek(1),
            },
          ]}
        />
      </MenuBarItem>
    </MenuBar>
    {#if dialogCurrentlyDisplayed === "menuSelection"}
      <MenuBarMenuDialog onClose={onClickSettingsDialogClose}>
        <MenuBarMenuDialogButton onClick={() => dialogCurrentlyDisplayed = "displaySettings"}>
          {translate("frontend:ganttChart.settings.sections.displaySettings.title")}
        </MenuBarMenuDialogButton>
        <MenuBarMenuDialogButton onClick={() => dialogCurrentlyDisplayed = "filter"}>
          {translate("generic.filterShort")}
        </MenuBarMenuDialogButton>
      </MenuBarMenuDialog>
    {/if}
    {#if dialogCurrentlyDisplayed === "displaySettings"}
      <LoadGraphDisplaySettingsMenuDialog
        {unitPeriod}
        {displayPeriod}
        maxValue = {$rowNumMaxValue}
        onClose={() => dialogCurrentlyDisplayed = null}
      />
    {/if}
    {#if dialogCurrentlyDisplayed === "filter"}
      <LoadGraphFilterMenuDialog
        option_resourceCodes = {$FilterableItems["ResCodeFilter"]}
        option_processes = {$FilterableItems["ProcessFilter"]}
        option_groups = {$FilterableItems["GroupFilter"]}
        option_shifts = {$FilterableItems["ShiftFilter"]}
        handleClearAllFilters={handleClearAllFilters}
        onClose={() => dialogCurrentlyDisplayed = null}
      />
    {/if}
    <div class="table-container">
      {#each ['グループ', '資源コード', '工程', '勤務シフト'] as header, index}
        {#if index === 0}
          <LoadTableArea 
            header={header}
            rowHeight={$rowHeight}
            bind:normalHeader={tableHeader}
            visibleRows={$visibleRows}
            previousRow={previousRow}
            handleScrollRowNum={handleScrollRowNum}
            index={index}
            startDrag={startDrag}
            option_groups = {$FilterableItems["GroupFilter"]}
            rowWidth={$tableAreaWidth[index]}
          />
        {:else}
          <LoadExtraTableArea 
            header={header}
            rowHeight={$rowHeight}
            visibleRows={$visibleRows}
            handleScrollRowNum={handleScrollRowNum}
            index={index}
            startDrag={startDrag}
            option_resourceCodes = {$FilterableItems["ResCodeFilter"]}
            option_processes = {$FilterableItems["ProcessFilter"]}
            option_shifts = {$FilterableItems["ShiftFilter"]}
            rowWidth={$tableAreaWidth[index]}
          />
        {/if}
      {/each}
      <LoadDataArea 
        rowHeight={$rowHeight}
        cellWidth={$cellWidth}
        selectedUnitPeriod={selectedUnitPeriod}
        timeGroupsDay={$timeGroupsDay}
        timeGroupsWeek={$timeGroupsWeek}
        timeGroupsMonth={$timeGroupsMonth}
        visibleDays={$visibleDays}
        visibleWeeks={$visibleWeeks}
        visibleMonths={$visibleMonths}
        visibleRows={$visibleRows}
        viewMode={viewMode}
        handleScrollPeriodHeader={handleScrollPeriodHeader}
        handleScrollPeriodBody={handleScrollPeriodBody}
      />

    </div>
    {#if $visibleRows.length == 0}
      <div class="empty-container">
        <p class="empty-statement">該当する{emptyText}は存在しませんでした</p>
      </div>
    {/if}
    <div class="bottom-buttons" style="margin-left: {$border}px; width: {$tableAreaWidth[0]}px">
      <div class="bottom-button3" on:click={() => nextRow(0)}>
        <!-- on:click={() => nextRow(0)} -->
        <img src="/assets/rss_down.svg" alt="rss_down" />
      </div>
      <div class="bottom-button4" on:click={() => nextRow(1)}>
        <img src="/assets/rss_pagedown.svg" alt="rss_pagedown" />
      </div>
    </div> 
  </div>
{:else}

  <Loading />
{/if}

<style>
  .table-body{
    height: 100%;
    width: 100%;
    overflow: hidden; 
  }

  .table-container {
    display: flex;
    flex-direction: row;
  }

  .bottom-buttons {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    border: none;
    background-color: #f5f5f5;
    height: 30px;
    user-select: none;
  }

  .bottom-button3,
  .bottom-button4 {
    width: 88px;
    height: 26px;
    border-radius: 0 0 7px 7px;
    background-color: #d2d0d2;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }

  .bottom-button3 img,
  .bottom-button4 img {
    max-width: 100%;
    max-height: 100%;
  }

  .empty-container {
    border-bottom: 2px solid #888888;
    border-right: 2px solid #888888;  
    border-left: 2px solid #888888;
  }
  .empty-statement {
    font-size: 16px;
    color: #888888;

    padding: 16px;
    margin: 0;
  }

  :global(.menu-bar-item) {
    padding-bottom: 0 !important;
  }
</style>
